import { render, staticRenderFns } from "./KolonneSettingsAssignedVehicle.vue?vue&type=template&id=0247eb36"
import script from "./KolonneSettingsAssignedVehicle.vue?vue&type=script&lang=js"
export * from "./KolonneSettingsAssignedVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports